import { z } from 'zod';

import { exploreEventSchema } from './explore-event';
import { exploreQuerySchema } from './explore-query';

export type ExploreEventsQuery = z.infer<typeof exploreEventsQuerySchema>;

export const exploreEventsQuerySchema = exploreQuerySchema.extend({
  event: exploreEventSchema,
});
